import { createSlice } from "@reduxjs/toolkit";
import { resolveDomainConfig } from "../../utils/domainResolver";

const domainConfig = resolveDomainConfig();

const initialState = {
  baseURL: domainConfig.baseURL,
  domain: domainConfig.hostname,
  title: domainConfig.title,
  isAllowedDomain: domainConfig.isAllowedDomain,
  isPartsURL: domainConfig.isPartsURL,
  isAccessoriesURL: domainConfig.isAccessoriesURL,
  isMobileURL: domainConfig.isMobileURL,
  isBerlinURL: domainConfig.isBerlinURL,
  isGodownURL: domainConfig.isGodownURL,
  isHandyweltURL: domainConfig.isHandyweltURL,
  isAlmasURL: domainConfig.isAlmasURL,
  isKolenURL: domainConfig.isKolenURL,
  isMobileLikeURL: domainConfig.isMobileLikeURL,
  hideProductRamStorage: domainConfig.hideProductRamStorage,
};

const domainSlice = createSlice({
  name: "domain",
  initialState,
  reducers: {},
});

export default domainSlice.reducer;
